import * as types from '../../constants/log/basicMissionLogConstants';

export const basicMissionLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  missionIndex,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  missionIndex,
  callback,
  error,
});
